<template>
    <el-dialog
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      title="拆分工单" 
      :visible.sync="dialogVisible"
      top="5vh"
      width="85%" 
      :before-close="handleClose">

      <el-table
        :data="subTicketList">
        <el-table-column label="处理人" width="200">
          <DealUserSearch slot-scope="scope" v-model="scope.row.dealUserId"/>
        </el-table-column>

        <el-table-column label="标题">
          <el-input slot-scope="scope" v-model="scope.row.orderTitle" placeholder="工单标题"/>
        </el-table-column>

        <el-table-column label="抄送" width="250">
          <NoticeUserSearch slot-scope="scope" v-model="scope.row.ticketCcIds"/>
        </el-table-column>

        <el-table-column label="类型" width="200">
          <TicketTypeCascader
            slot-scope="scope"
            css="width:100%"
            v-model="scope.row.orderType" />
        </el-table-column>

        <el-table-column label="工时" width="200">
          <el-input-number 
            slot-scope="scope"
            v-model="scope.row.workHour"
            placeholder="工时"
            :precision="1"
            :min="0"/>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addRow" style="float:left;">+</el-button>
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="doSubmit" :disabled="buttonDisabled">提交</el-button>
      </span>
    </el-dialog>
</template>

<script>
export default {
  name: "TicketSplitDialog",

  data() {
    return {
      dialogVisible: false,
      subTicketList: [],
      buttonDisabled: false
    };
  },

  methods: {
    addRow() {
      this.subTicketList.push({
        orderTitle: this.ticket.orderTitle
      });
    },

    show(_ticket) {
      this.ticket = _ticket;

      this.subTicketList = [{
        orderTitle: _ticket.orderTitle
      }];

      var _this = this;
      _this.dialogVisible = true;
    },

    // 提交
    doSubmit() {
      var _this = this;

      this.buttonDisabled = true;

      setTimeout(() => {
        _this.buttonDisabled = false;
      }, 5000); // 按钮 5 秒后 解封


      _this.subTicketList.forEach(e => {
        e.orderNoticeList = !e.ticketCcIds ? [] : e.ticketCcIds.map( e => {
          return { noticeUserId : e}
        });
      });

      sdk.TicketApi().ticketSplit({
        ticketNo: _this.ticket.orderId,
        subTicketList: _this.subTicketList
      }).then(() => {
        _message('工单拆分成功');

        _this.dialogVisible = false;
      });
    },

    // 弹出层关闭
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style>
.TicketMailSendDialogForm {
    padding:0 10px;
}

.TicketMailSendDialogForm .el-form-item {
    margin-bottom:0;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketSplitDialog.vue